import React, { FC } from 'react'
import WineDataColumn from 'components/Common/Table/WineDataColumn'
import EmptyIcon from '../EmptyIcon'
import { ProductWrapper, ImageWrapper, Image, InfoWrapper } from '../_styles'
import { Product } from 'api/schemas'

interface RecognizedProductProps {
  images: string[]
  onImageClick: (images: string[]) => void
  renderImageCounter: (count: number) => React.ReactNode
  product: Product
  testIdPrefix?: string
}

const RecognizedProduct: FC<RecognizedProductProps> = ({
  images,
  onImageClick,
  renderImageCounter,
  product,
  testIdPrefix,
}) => {
  const hasImages = images.length > 0

  return (
    <ProductWrapper
      data-testid={
        testIdPrefix ? `${testIdPrefix}-recognized-product` : undefined
      }
    >
      <ImageWrapper onClick={() => onImageClick(images)}>
        {hasImages ? (
          <>
            <Image
              src={images[0]}
              alt='Product image'
              data-testid={
                testIdPrefix ? `${testIdPrefix}-recognized-image` : undefined
              }
            />
            {renderImageCounter(images.length)}
          </>
        ) : (
          <EmptyIcon />
        )}
      </ImageWrapper>
      <InfoWrapper>
        <WineDataColumn product={product} noLinks fontMode='M' badgeSize={16} />
      </InfoWrapper>
    </ProductWrapper>
  )
}

export default RecognizedProduct
